import { render, staticRenderFns } from "./BrandBookmarkContainerViewer.vue?vue&type=template&id=14dffaee&scoped=true&"
import script from "./BrandBookmarkContainerViewer.vue?vue&type=script&lang=ts&"
export * from "./BrandBookmarkContainerViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dffaee",
  null
  
)

export default component.exports